<template>
  <section class="success">
    <popupok
      v-if="activeOk === true"
      :want-to-make-offer="activeOk"
      message="Projet enregistrer avec succès"
      @oga="retourOk"
    />
    <popup-base
      v-show="wantToMakeOffer && activeOk === false"
      class="popo md:pt-10 md:pb-4"
      @clickOnBackground="logState"
    >
      <div
        class="success-container"
      >
        <svg-icon
          name="close"
          class="h-4 cursor-pointer mb-6"
          original
          @click="fermer"
        />

        <div class="titre text-left"  @click="closeAll">
          Écrivez-nous et notre conseiller clientèle vous répondra avec des questions sur votre projet.
        </div>

        <div class="mt-16">
          <div class="md:flex">
            <div
              class="md:w-1/3 w-full mr-12"
              @click="openStation(1)"
            >
              <selecte
                :option="optionSelect"
                placeholder="Civilité"
                :index="1"
                :position="stade"
                @info="retourCivilite"
              />
            </div>

            <div class="md:w-2/3 w-full md:mt-0 mt-6" @click="closeAll">
              <inputo
                placeholder="Nom complet"
                @info="retourName"
              />
            </div>
          </div>

          <div class="md:flex md:mt-10 mt-6" @click="closeAll">
            <div class="md:w-1/2 w-full mr-12">
              <inputo
                placeholder="Organisation/Société"
                @info="retourSociete"
              />
            </div>

            <div class="md:w-1/2 w-full md:mt-0 mt-6">
              <inputo
                placeholder="Position"
                @info="retourPosition"
              />
            </div>
          </div>

          <div class="md:flex md:mt-10 mt-6">
            <div
              class="md:w-1/2 w-full mr-12"
              @click="openStation(2)"
            >
              <selecte
                :index="2"
                :position="stade"
                :option="optionPays"
                placeholder="Pays"
                @info="retourPays"
              />
            </div>

            <div class="md:w-1/2 w-full md:mt-0 mt-6" @click="closeAll">
              <inputo
                placeholder="Ville"
                @info="retourVille"
              />
            </div>
          </div>

          <div class="md:flex md:mt-10 md:mb-10 mt-6" @click="closeAll">
            <inputo
              placeholder="Email"
              @info="retourEmail"
            />
          </div>

          <div class="md:flex md:mt-10 mt-6">
            <div class="md:w-1/3 w-full mr-12" @click="openStation(3)">
              <selecte
                :index="3"
                :position="stade"
                :option="optionObject"
                placeholder="Objet de votre message"
                @info="retourObjet"
              />
            </div>

            <div class="md:w-2/3 w-full md:mt-0 mt-6" @click="closeAll">
              <textareaa
                placeholder="Dites-nous comment on peut vous aider"
                @info="retourMessage"
              />
            </div>
          </div>

          <div
            v-if="error !== null"
            class="text-center text-red mt-8"
          >
            {{ error }}
          </div>

          <div class="md:mt-12">
            <div
              class="button mt-16"
              @click="sendMessage"
            >
              <scale-loader
                v-if="charge === true"
                :color="loaderColor"
                class="text-center"
              />
              <span v-if="charge === false">
                Envoyer un message
              </span>
            </div>
          </div>

          <div class="mt-4">
            <!--            <div-->
            <!--              class="button mt-16"-->
            <!--              @click="sendMessage"-->
            <!--            >-->
            <!--              Envoyer un message-->
            <!--            </div>-->
          </div>
        </div>
      </div>
    </popup-base>
  </section>
</template>

<script>
import PopupBase from '../helper/add/popup-base'
import selecte from '@/components/helper/form/select'
import inputo from '@/components/helper/form/input'
import textareaa from '@/components/helper/form/textarea'
import axios from 'axios'
import popupok from '@/components/popup/popupok'
import ScaleLoader from 'vue-spinner/src/BeatLoader'
import pays from './pays.json'

export default {
  name: 'Success',
  components: { PopupBase, selecte, inputo, textareaa, popupok, ScaleLoader },
  props: {
    wantToMakeOffer: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loaderColor: '#FFF',
      charge: false,
      optionSelect: ['M.', 'Mme.'],
      optionObject: ['Solution d’assurances', 'Solution de banking', 'Solution de santé', 'Non repertoriée'],

      optionPays: pays,
      pays: '',
      object: '',
      civilite: '',
      nom: '',
      societe: '',
      position: '',
      ville: '',
      email: '',
      message: '',
      activeOk: false,
      error: null,
      stade: 0
    }
  },
  computed: {
  },

  methods: {
    sendMessage () {
      this.error = null
      if (this.nom !== null && this.email !== null) {
        this.charge = true
        axios.defaults.withCredentials = true
        axios.defaults.headers.common['x-api-key'] = '3add749b-768b-45ec-a7db-91d3c1915b76'
        const content = 'nom: ' + this.nom + '; Civilité: ' + this.civilite + '; Organisation/Société: ' + this.societe + '; Position: ' + this.position + '; Pays: ' + this.pays + '; Ville: ' + this.ville + '; Email:' + this.email + ' Objet: ' + this.object + '; Description: ' + this.message

        axios.post('https://octabis.kgeek.me/api/v1/utilities/send-mail', {
          'receiver': 'contact@41devs.com',
          'sender': this.email,
          'senderName': this.nom,
          'object': 'NOUVEAU PROJET',
          'content': content
        }).then(response => {
          this.activeOk = true
          this.charge = false
        }).catch(error => {
          this.charge = false
          console.log(error)
          this.error = 'Veuillez verifier les informations entrer et ressayer'
        })
      } else {
        this.error = 'Veuillez remplir les champs et ressayer'
      }
    },
    closeAll () {
      this.stade = 0
    },

    openStation (index) {
      if (index === this.stade) {
        this.stade = 0
      } else {
        this.stade = index
      }
    },

    retourCivilite (answer) {
      this.civilite = answer
    },

    retourMessage (answer) {
      this.message = answer
    },
    retourOk (answer) {
      this.activeOk = answer
    },
    retourObjet (answer) {
      this.object = answer
    },
    retourEmail (answer) {
      this.email = answer
    },
    retourVille (answer) {
      this.ville = answer
    },
    retourPays (answer) {
      this.pays = answer
    },
    retourPosition (answer) {
      this.position = answer
    },
    retourSociete (answer) {
      this.societe = answer
    },
    retourName (answer) {
      this.nom = answer
    },
    retourHover (answer) {
      this.activeHover = answer
    },
    fermer () {
      this.activeOk = false
      this.$emit('oga', false)
    },
    yes () {
      this.activeOk = false
      this.$emit('oga', true)
    },
    logState (answer) {
      this.wantToMakeOffer = answer
      this.$emit('oga', false)
      this.activeOk = false
    }
  }
}
</script>

<style lang="scss"  scoped>
    @import "../../assets/style/sass/mixin";

    .success-container {
      width: 70%;
      background-color: $white;
      padding: 40px 40px 50px 40px;
      height: auto;
      margin: auto;
    }
    .titre{
      font-style: normal;
      font-weight: normal;
      font-size: 28.3206px;
      line-height: 160%;
    }
    .button{
      background-color: $dev-green;
      width: 226.56px;
      height: 47.2px;
      border-radius: 0px;
      border: none;
      font-weight: 600;
      font-size: 18.8804px;
      line-height: 23px;
      color: $white;
    }
    .detail, .detail{
      font-size: 24px;
      line-height: 180%;
    }
    .mail, .contact{
      font-weight: bold;
      font-size: 24px;
      line-height: 180%;
    }
    .mail{
      text-decoration-line: underline;
    }

    @media screen and (max-width: 700px){
      .success-container {
        width: 100%;
      }
      .titre{
        font-size: 20px;
      }
      .bloc1{
        width: 100%;
      }
      .bloc2{
        width: 100%;
        font-size: 18px;
      }
      .titre1{
        font-size: 20px;
      }
      .ico{
        height: 15px;
      }
      .title3{
        font-size: 18px;
      }
      .button{
        width: 100%;
      }
    }
</style>
